import * as React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { RecordContextProvider, useListContext } from 'react-admin';
import { FundCard } from './FundCard';
import { Fund } from '../../types/types';

const times = (nbChildren: number, fn: (key: number) => any) =>
    Array.from({ length: nbChildren }, (_, key) => fn(key));

const LoadingGridList = () => (
    <Box display="flex" flexWrap="wrap" width={1008} gap={1}>
        {times(15, key => (
            <Paper
                sx={{
                    height: 200,
                    width: "100%", // Adjusted width for 1 item per row
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'grey[200]',
                }}
                key={key}
            />
        ))}
    </Box>
);

const LoadedGridList = () => {
    const { data, error, isPending } = useListContext<Fund>();
    if (isPending || error) return null;
    return (
        <Box
            width="100%"
            gap={1}
            display="grid"
            gridTemplateColumns="1fr" // Changed to show exactly 1 item per row
        >
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <FundCard />
                </RecordContextProvider>
            ))}
            {data.length === 0 && (
                <Typography p={2}>No funds found</Typography>
            )}
        </Box>
    );
};

export const ImageList = () => {
    const { isPending } = useListContext();
    return isPending ? <LoadingGridList /> : <LoadedGridList />;
};